export default __webpack_public_path__ + "media/images/user/badge-deac1a6c0608705d0a0a623e0fef7b5b.png";